import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextArea from "../../components/form/TextArea";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import {FormDataToJson} from '../../utils/json/Json';
import PAGES from '../../config/Pages';
import Alert from "../../components/alert/Alert";
import SimpleAlert from "../../components/alert/types/SimpleAlert";
import SelectAjax from "../../components/form/SelectAjax";

const URL_SAVE = WS.mensagens.save;

class NewMessage extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      wrapper: Random(7),
      strings: STRINGS[window.LANGUAGE]
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentDidMount() {

  }

  handleSelectChange = (newValue) => {
    this.setState({
      cliente: newValue.value
    });
  };

  handleSubmit (e){
    e.preventDefault();
    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaTodosCampos,
      digiteMensagem,
      erroSalvar
    }
    = this.state.strings;

    const formData = new FormData(e.target);

    //retorna todos os exercicios adicionados
    let idForm = e.target.getAttribute('id');
    //transforma o formData em um json
    var object = FormDataToJson(formData);

    object.id_cliente = this.state.cliente;

    if(!object.mensagem && !object.assunto && !object.id_cliente){
      var msg = {
        title: atencao,
        text: preenchaTodosCampos
      };
      Dialog.create(msg);
      return false;
    }

    const history = this.props.history;

    //----------------
    Requisitions({
      url: URL_SAVE,
      data: object,
      sucess:function(data){
        var msg;
        history.push(PAGES.mensagens);
        _self.props.modal.close();
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  onHandlerInput(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render (){
    const { titleNewMessage, enviar } = this.state.strings;

    const
    {
      digiteAqui,
      nenhumItem,
      assuntoTitle,
      selecioneCliente,
      titleMensagem
    } = this.state.strings;

    return (
      <div className='box-cadastro-bloco'>
        <MainTitle title={titleNewMessage}></MainTitle>
        <form id="form-new-message" onSubmit={this.handleSubmit}>
          <div className="">
            <SelectAjax
              noResultsText={nenhumItem}
              onChange={this.handleSelectChange}
              url={WS.clientes.search}
              title={selecioneCliente} />
          </div>
          <div className="">
            <TextInput
              name="assunto"
              value=''
              title={assuntoTitle}
              placeholder={digiteAqui}>
            </TextInput>
          </div>
          <div className="">
            <TextArea
              name="mensagem"
              title={titleMensagem}
              value=''
              placeholder="">
            </TextArea>
          </div>
          <br />
          <div className="box-right-button"><Button type="submit" text={enviar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default NewMessage;



// WEBPACK FOOTER //
// ./src/classes/mensagens/NewMessage.js